import { useChatAuthorization } from "@faire/help-center-self-serve/chat/hooks/useChatAuthorization";
import { Anchor } from "@faire/web/ui/LinkAnchor";
import React from "react";
import { DesktopChat } from "../view/Answer/DesktopChat";
export var MobileChat = function MobileChat(_ref) {
  var to = _ref.to,
    disableChat = _ref.disableChat,
    onClick = _ref.onClick,
    loading = _ref.loading;
  var _useChatAuthorization = useChatAuthorization(),
    chatBtnEnabled = _useChatAuthorization.chatBtnEnabled;
  var chat = /*#__PURE__*/React.createElement(DesktopChat, {
    onClick: onClick,
    disableChat: disableChat,
    loading: loading
  });
  if (!chatBtnEnabled) {
    return chat;
  }
  return /*#__PURE__*/React.createElement(Anchor, {
    href: to,
    "data-test-id": "mobile-chat-link"
  }, chat);
};